import { NgModule } from '@angular/core';
import { FormModule } from 'lib/ui/form/form.module.js';
import { ScheduleModule } from 'lib/ui/schedule/index.js';
import { CoreModule } from 'src/app/core/core.module.js';
import { DiaryModule } from '../diary/diary.module.js';
import { PackagesModule } from '../packages/packages.module.js';
import { ProgressModule } from '../progress/progress.module.js';
import { SessionsModule } from '../sessions/sessions.module.js';
import { TasksModule } from '../tasks/tasks.module.js';
import { AccountReadyComponent } from './account-ready/account-ready.component.js';
import { ListAdminUserTemplatesComponent } from './admin/list-admin-user-templates.component.js';
import { ListAdminUsersComponent } from './admin/list-admin-users.component.js';
import { ViewAdminUserComponent } from './admin/view-admin-user.component.js';
import { ClientOverviewComponent } from './client-overview.component.js';
import { ClientDiaryComponent } from './diary/client-diary.component.js';
import { EditClientAvatarComponent } from './edit-client-avatar.component.js';
import { EditClientPackagesComponent } from './edit-client-packages.component.js';
import { EditClientComponent } from './edit-client.component.js';
import { EditMyAvatarComponent } from './edit-my-avatar.component.js';
import { EditMySettingsComponent } from './edit-my-settings.component.js';
import { EditUserPasswordComponent } from './edit-user-password.component.js';
import { ClientFilesComponent } from './files/client-files.component.js';
import { ClientGalleryComponent } from './gallery/client-gallery.component.js';
import { ListClientsComponent } from './list-clients.component.js';
import { MyNotificationsComponent } from './my-notifications.component.js';
import { NewClientComponent } from './new-client.component.js';
import { ClientDietComponent } from './nutrition/client-diet.component.js';
import { ClientProgressComponent } from './progress/client-progress.component.js';
import { ClientSessionsComponent } from './sessions/client-sessions.component.js';
import { SignupFormComponent } from './signup/sign-up-form.component.js';
import { ClientTasksComponent } from './tasks/client-tasks.component.js';
import { ClientTrainingComponent } from './training/client-training.component.js';
import { UserPreferredUnitComponent } from './unit/user-preferred-unit.component.js';

@NgModule({
	declarations: [
		EditClientComponent,
		ClientOverviewComponent,
		ListClientsComponent,
		NewClientComponent,
		EditMySettingsComponent,
		MyNotificationsComponent,
		ClientTrainingComponent,
		ClientDietComponent,
		ClientProgressComponent,
		ClientFilesComponent,
		ClientGalleryComponent,
		ClientTasksComponent,
		ClientDiaryComponent,
		EditUserPasswordComponent,
		ClientSessionsComponent,
		ListAdminUsersComponent,
		EditClientAvatarComponent,
		EditMyAvatarComponent,
		EditClientPackagesComponent,
		ListAdminUserTemplatesComponent,
		UserPreferredUnitComponent,
		ViewAdminUserComponent,
		AccountReadyComponent,
		SignupFormComponent
	],
	exports: [
		EditClientComponent,
		ClientOverviewComponent,
		ListClientsComponent,
		NewClientComponent,
		EditMySettingsComponent,
		MyNotificationsComponent,
		ClientTrainingComponent,
		ClientDietComponent,
		ClientProgressComponent,
		ClientFilesComponent,
		ClientGalleryComponent,
		ClientTasksComponent,
		ClientDiaryComponent,
		EditUserPasswordComponent,
		ClientSessionsComponent,
		ListAdminUsersComponent,
		EditClientAvatarComponent,
		EditMyAvatarComponent,
		EditClientPackagesComponent,
		ListAdminUserTemplatesComponent,
		UserPreferredUnitComponent,
		ViewAdminUserComponent,
		AccountReadyComponent,
		SignupFormComponent
	],
	imports: [
		CoreModule,
		FormModule,
		ScheduleModule,
		ProgressModule,
		TasksModule,
		DiaryModule,
		PackagesModule,
		SessionsModule
	]
})
export class UsersModule {}
